import axios from "axios"
import {isRequestError, RequestError} from "../../Model/RequestError";
import {BraintreeClientToken} from "../../Model/Sales/BraintreeClientToken";
import {acceptHeader, executeWithErrorResponseHandling} from "../ApiUtilities";
import {joinUrl} from "../../Utilities/UriUtilities";
import {COUNTER_API_CALLS} from "../../Service/CounterMetricsProvider";

/**
 * Function is responsible for creating a Braintree client token.
 */
export const createBraintreeClientToken = async (domain: string): Promise<BraintreeClientToken | RequestError> => {
    const endpoint = joinUrl(domain, "/payments/braintree/generate-client-token")
    const headers = {...acceptHeader()}

    const response = await executeWithErrorResponseHandling<BraintreeClientToken>(() =>
        axios.post(endpoint, {}, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/payments/braintree/generate-client-token", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/payments/braintree/generate-client-token", "status": "success"}})
        return response.data
    }
}